import { get, post } from '@/core/request';
import cookies from 'js-cookie';

const getCustomHeaders = () => {
  const headers = {};
  const spaceId = cookies.get('spaceId');
  headers['x-toca-user-token'] = cookies.get('token');
  headers['x-toca-userid'] = cookies.get('userId');
  headers['x-toca-deviceid'] = cookies.get('deviceId');
  headers['is-replace-all'] = true;
  return headers;
};

let baseURL = process.env.VUE_APP_INTERNET_URL;
if (process.env.NODE_ENV == 'development') {
  baseURL = '';
}


// 管家打分接口
//@feedbackScore 传用户反馈的分值 1-5
export const apiScoreRate = (feedbackScore) => {
  const dataMap = {
    id: "-1", // 传固定值
    name: "管家文档评分", // 传固定值
    questionnaireContents: [
      {
        contentType: "SCORE", // 传固定值
        content: {
          title: "给管家文档打个分吧~", // 传固定值
          scores: [
            { score: 1, desc: "不好用 完全不行" },
            { score: 2, desc: "凑合能用 还行" },
            { score: 3, desc: "符合预期 还不错" },
            { score: 4, desc: "超过预期 非常好" },
            { score: 5, desc: "天大的惊喜 太棒了" },
          ],
          feedbackScore: feedbackScore, // 传用户反馈的分值 1-5
        },
      },
    ],
    submitSource: "DOCUMENT", // 传固定值
  };

  const userId = cookies.get('userId');
  const spaceId = cookies.get('spaceId');
  const deviceId = cookies.get('deviceId');
  const token = cookies.get('token');
  const memberId = cookies.get('memberId');
  const headers = {
    token: token, // 传token
    userId: userId, // 传用户id
    deviceId: deviceId, // 传设备id
    spaceId: spaceId, // 传空间id
    "x-toca-context": encodeURI(
      JSON.stringify({
          userId,
          spaceId,
          appId: 'com.ly.master',
          deviceId,
          memberId,
      })
    )
  };
  const options = {
    data: dataMap,
    headers: headers,
    url: '/config/questionnaire/submit',
    baseURL: baseURL,
  }
  return post(options);
};
